export default __webpack_public_path__ + "static/media/settings.fd9cb79a.png";